import { render, staticRenderFns } from "./video-streamer-status.vue?vue&type=template&id=1bc3d0b4&scoped=true&"
import script from "./video-streamer-status.vue?vue&type=script&lang=js&"
export * from "./video-streamer-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc3d0b4",
  null
  
)

export default component.exports